import React from 'react'

const CloseIcon = props => {
  const height = props.height || 20
  const width = props.width || 20
  return (
    <svg width={width} height={height} viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
      <g stroke="#2A779A" fill="none" fill-rule="evenodd">
        <circle cx="15" cy="15" r="12" />
        <path d="M20 10 10 20m10 0L10 10" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  )
}

export default CloseIcon
